
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Font } from "@/types/fonts";
import BrandTypographyFont from "./BrandTypographyFont.vue";
import IconButton from "@/components/UI/IconButton.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";

type CATEGORY =
  | "sans-serif"
  | "serif"
  | "display"
  | "handwriting"
  | "monospace";

const representativeFontFamiliy: { [key in CATEGORY]: string } = {
  "sans-serif": "Inter",
  serif: "Playfair Display",
  display: "Alfa Slab One",
  handwriting: "Caveat Brush",
  monospace: "Roboto Mono"
};

@Component({
  components: {
    BrandTypographyFont,
    IconButton,
    TextInput
  }
})
export default class TypographyCategory extends Vue {
  isOpen = false;
  filter = "";

  @Prop()
  label!: CATEGORY;

  @Prop()
  fonts!: Font[];

  updateFilter(value: string) {
    this.filter = value;
  }

  open() {
    this.isOpen = true;
    this.$emit("show", this.label);
  }

  close() {
    this.isOpen = false;
    this.$emit("show", "");
  }

  get filteredFonts() {
    return this.fonts.filter((font: Font) => {
      return font.label.toLowerCase().includes(this.filter.toLowerCase());
    });
  }

  get searchInputPlaceholder() {
    return `Search ${this.label} fonts`;
  }

  update(font: Font) {
    this.$emit("update", font);
  }

  getRepresentativeFont(fonts: Font[], category: CATEGORY): Font | null {
    const representativeFont = fonts.find((font: Font) => {
      return font.label === representativeFontFamiliy[category];
    });

    if (representativeFont) {
      return representativeFont;
    }

    return null;
  }

  get representativeFont() {
    const category = this.label as CATEGORY;
    return this.getRepresentativeFont(this.fonts, category);
  }
}
